// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Backup.css */

.backup-container {
    padding: 20px;
    font-family: Arial, sans-serif;
    background-color: var(--white-color);
}

.request-button {
    float: right;
    background-color: var(--second-color);
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: var(--font-size-med);
    border-radius: 4px;
    margin-bottom: 20px;
    margin-left: 30px;
}

.request-button:hover {
    background-color: #0056b3;
}

.cards-container {
    display: flex;
    gap: 15px;
    margin-bottom: 10px;
}

.cardBackUp {
    background-color: var(--white-color);
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    flex: 1 1;
    text-align: center;
    border: 1px solid var(--border-table-color);
}

.cardBackUp h3 {
    color: #333;
    font-size: 18px;
    /* margin-bottom: 10px; */
}

.cardBackUp p {
    color: #007bff;
    font-size: 20px;
    font-weight: bold;
}

.backup-config {
    background-color: var(--white-color);
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid var(--border-table-color);
}

.backup-config h2 {
    font-size: var(--font-size-med);
    color: #333;
    margin-bottom: unset;
}

.config-field {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.config-field label {
    flex: 1 1;
    font-size: 16px;
    color: #333;
}

.config-field select,
.config-field input[type="time"],
.config-field input[type="checkbox"] {
    flex: 2 1;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: var(--white-color);
    color: var(--txt-color);
}

.update-config-button {
    background-color: var(--second-color);
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    font-size: var(--font-size-xSmall);
    border-radius: 4px;
}

.update-config-button:hover {
    background-color: #0056b3;
}

.backup-history {
    background-color: var(--white-color);
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 10px;
    border: 1px solid var(--border-table-color);
}

.backup-history h2 {
    font-size:var(--font-size-med);
    color: #333;
    margin-bottom: unset;
}

.history-table {
    width: 100%;
    border-collapse: collapse;
}

.history-table th,
.history-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

.history-table th {
    background-color: #f2f2f2;
    color: #333;
}

.history-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.history-table tr:hover {
    background-color: #e2e2e2;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background-color: var(--white-color);
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.modal-content h2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 15px;
}

.modal-content p {
    font-size: 14px;
    color: #555;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
    text-align: left;
}

.form-group label {
    font-size: 14px;
    color: #333;
    display: block;
    margin-bottom: 5px;
}

.form-group select,
.form-group textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: var(--white-color);
    color: var(--txt-color);
}

.form-group textarea {
    resize: vertical;
    min-height: 80px;
}

.modal-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

.modal-buttons button {
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;
    border-radius: 4px;
    border: none;
}

.modal-buttons button:last-child  {
    background-color: #007bff;
    color: white;
}

.modal-buttons button:last-child :hover {
    background-color: #0056b3;
}

.modal-buttons button:first-child{
    background-color: #ccc;
    color: #333;
}

.modal-buttons button:first-child:hover {
    background-color: #999;
}

.content-portafolio-footer-min{
    position: relative;
  justify-content: end;
  align-items: center;
  display: flex;
  height: 30px !important;
  width: 100%;
  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);
  border: 1px solid var(--border-table-color);
}



.flex-wrapper {
  display: flex;
  flex-flow: row nowrap;
}

.single-chart {
  width: 33%;
  justify-content: space-around ;
}

.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 80%;
  max-height: 250px;
}

.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
}

@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart.orange .circle {
  stroke: #ff9f00;
}

.circular-chart.green .circle {
  stroke: #4CC790;
}

.circular-chart.blue .circle {
  stroke: #3c9ee5;
}

.percentage {
  fill: #666;
  font-family: sans-serif;
  font-size: 0.5em;
  text-anchor: middle;
}`, "",{"version":3,"sources":["webpack://./src/components/respaldo-components/Backup/Backup-styles/Backup.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;IACI,aAAa;IACb,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,SAAO;IACP,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,WAAW;AACf;;AAEA;;;IAGI,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,4EAA4E;EAC5E,2CAA2C;AAC7C;;;;AAIA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Backup.css */\r\n\r\n.backup-container {\r\n    padding: 20px;\r\n    font-family: Arial, sans-serif;\r\n    background-color: var(--white-color);\r\n}\r\n\r\n.request-button {\r\n    float: right;\r\n    background-color: var(--second-color);\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    cursor: pointer;\r\n    font-size: var(--font-size-med);\r\n    border-radius: 4px;\r\n    margin-bottom: 20px;\r\n    margin-left: 30px;\r\n}\r\n\r\n.request-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.cards-container {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.cardBackUp {\r\n    background-color: var(--white-color);\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    flex: 1;\r\n    text-align: center;\r\n    border: 1px solid var(--border-table-color);\r\n}\r\n\r\n.cardBackUp h3 {\r\n    color: #333;\r\n    font-size: 18px;\r\n    /* margin-bottom: 10px; */\r\n}\r\n\r\n.cardBackUp p {\r\n    color: #007bff;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.backup-config {\r\n    background-color: var(--white-color);\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid var(--border-table-color);\r\n}\r\n\r\n.backup-config h2 {\r\n    font-size: var(--font-size-med);\r\n    color: #333;\r\n    margin-bottom: unset;\r\n}\r\n\r\n.config-field {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.config-field label {\r\n    flex: 1;\r\n    font-size: 16px;\r\n    color: #333;\r\n}\r\n\r\n.config-field select,\r\n.config-field input[type=\"time\"],\r\n.config-field input[type=\"checkbox\"] {\r\n    flex: 2;\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    background: var(--white-color);\r\n    color: var(--txt-color);\r\n}\r\n\r\n.update-config-button {\r\n    background-color: var(--second-color);\r\n    color: white;\r\n    border: none;\r\n    padding: 10px 20px;\r\n    cursor: pointer;\r\n    font-size: var(--font-size-xSmall);\r\n    border-radius: 4px;\r\n}\r\n\r\n.update-config-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.backup-history {\r\n    background-color: var(--white-color);\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    padding: 10px;\r\n    border: 1px solid var(--border-table-color);\r\n}\r\n\r\n.backup-history h2 {\r\n    font-size:var(--font-size-med);\r\n    color: #333;\r\n    margin-bottom: unset;\r\n}\r\n\r\n.history-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.history-table th,\r\n.history-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n    text-align: left;\r\n}\r\n\r\n.history-table th {\r\n    background-color: #f2f2f2;\r\n    color: #333;\r\n}\r\n\r\n.history-table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.history-table tr:hover {\r\n    background-color: #e2e2e2;\r\n}\r\n\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n    background-color: var(--white-color);\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 400px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    text-align: center;\r\n}\r\n\r\n.modal-content h2 {\r\n    font-size: 20px;\r\n    color: #333;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.modal-content p {\r\n    font-size: 14px;\r\n    color: #555;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 15px;\r\n    text-align: left;\r\n}\r\n\r\n.form-group label {\r\n    font-size: 14px;\r\n    color: #333;\r\n    display: block;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.form-group select,\r\n.form-group textarea {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    background-color: var(--white-color);\r\n    color: var(--txt-color);\r\n}\r\n\r\n.form-group textarea {\r\n    resize: vertical;\r\n    min-height: 80px;\r\n}\r\n\r\n.modal-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.modal-buttons button {\r\n    padding: 8px 16px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    border: none;\r\n}\r\n\r\n.modal-buttons button:last-child  {\r\n    background-color: #007bff;\r\n    color: white;\r\n}\r\n\r\n.modal-buttons button:last-child :hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.modal-buttons button:first-child{\r\n    background-color: #ccc;\r\n    color: #333;\r\n}\r\n\r\n.modal-buttons button:first-child:hover {\r\n    background-color: #999;\r\n}\r\n\r\n.content-portafolio-footer-min{\r\n    position: relative;\r\n  justify-content: end;\r\n  align-items: center;\r\n  display: flex;\r\n  height: 30px !important;\r\n  width: 100%;\r\n  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);\r\n  border: 1px solid var(--border-table-color);\r\n}\r\n\r\n\r\n\r\n.flex-wrapper {\r\n  display: flex;\r\n  flex-flow: row nowrap;\r\n}\r\n\r\n.single-chart {\r\n  width: 33%;\r\n  justify-content: space-around ;\r\n}\r\n\r\n.circular-chart {\r\n  display: block;\r\n  margin: 10px auto;\r\n  max-width: 80%;\r\n  max-height: 250px;\r\n}\r\n\r\n.circle-bg {\r\n  fill: none;\r\n  stroke: #eee;\r\n  stroke-width: 3.8;\r\n}\r\n\r\n.circle {\r\n  fill: none;\r\n  stroke-width: 2.8;\r\n  stroke-linecap: round;\r\n  animation: progress 1s ease-out forwards;\r\n}\r\n\r\n@keyframes progress {\r\n  0% {\r\n    stroke-dasharray: 0 100;\r\n  }\r\n}\r\n\r\n.circular-chart.orange .circle {\r\n  stroke: #ff9f00;\r\n}\r\n\r\n.circular-chart.green .circle {\r\n  stroke: #4CC790;\r\n}\r\n\r\n.circular-chart.blue .circle {\r\n  stroke: #3c9ee5;\r\n}\r\n\r\n.percentage {\r\n  fill: #666;\r\n  font-family: sans-serif;\r\n  font-size: 0.5em;\r\n  text-anchor: middle;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
